<div class="my-5">
  <!-- page-header -->
  <sm-page-header
    [breadcrumb]="breadcrumb"
    [title]="'ppm.pages.version_history' | translate: { ppm_ref: ppmRepository.getNested('response', 'ref') }">
  </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder [dataTableObject]="datatableObject" [datas]="data || []" [loading]="loading"></sm-data-table-builder>
    <sm-dialog #dialog [dialog]="ppmDialog"></sm-dialog>
  </div>
</div>
